import AppShell from "../components/layout/AppShell";
import ServiceManagement from "../components/admin/ServiceManagement";

// Not in the main nav — reached from the Home footer. Services feed the
// "Add from services" shortcut in the quote builder.
export default function AdminServices() {
  return (
    <AppShell wide title="Services">
      <ServiceManagement />
    </AppShell>
  );
}
